import {
  Component,
  ElementRef,
  EventEmitter, HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {MessageService} from 'primeng/api'
import {Paginator} from 'primeng/paginator';
import {Observable, Observer, Subscription} from 'rxjs';
import {SharedConstant} from '../../constants/sharedConstants';
import {EmployeeDetails} from '../../models/EmployeeDetails';
import {empOrParticipantTableHeader, ManageEmpOrParticipantHeader} from '../../models/manage-employees-table-header';
import {SharedService} from '../../shared.service';
import * as temp from 'moment';
const moment = temp['default'];
import {ManageEmployeeDataService} from '../../services/manage-employee/manage-employee-data.service';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {AccountNumberValidationService} from '../../services/accountNumberValidation/account-number-validation.service';
import {ManageEmployeeOrParticpantListActionMenuItems} from '../../models/manage-employee-action-menu';
import { CustomSortService } from '../../services/custom-sort/custom-sort.service';
import { Router } from '@angular/router';
import { AccountNumberFormatPipe } from '../../pipes/account-number-format.pipe';


@Component({
  selector: 'ems-manage-employees',
  templateUrl: './shared-manage-employees.component.html',
  styleUrls: ['./shared-manage-employees.component.scss'],
  providers: [AccountNumberFormatPipe]
})

export class SharedManageEmployeesComponent implements OnInit, OnChanges, OnDestroy {
  constructor(public sharedService: SharedService, private el: ElementRef, public manageEmployeeDataService: ManageEmployeeDataService, @Inject('entitlementConst') public entitlementConst, public fb: UntypedFormBuilder,
              public accountNumberValidationService: AccountNumberValidationService,
              public customSortService: CustomSortService, public messageService: MessageService, public router: Router, public accountNumbeFormatPipe : AccountNumberFormatPipe) {
    this.sharedService.setHistoryResponse.subscribe(value => {
      this.empHistory.empHistoryData = value.data.content;
      this.empHistory.historyRecords = value.data.totalElements;
      this.empHistory.historyMessage = value.message;
    });
  }

  empHistory = {
    employeeId: '',
    historyId: '',
    empSubType: '',
    empHistoryData: '',
    historyRecords: '',
    historyMessage: '',
    empName: ''
  };
  landingPageMsg: any;
  currentOrgSubscription: Subscription;
  getOrgId: any;
  @Input() clientName: string;
  @Input() businessUnit: string;
  @Input() showColumns: any = true;
  @ViewChild('p', { static: true }) paginator: Paginator;
  @Output() editEvent = new EventEmitter<EmployeeDetails>();
  @ViewChild('viewHistory', { static: true }) viewHistoryData: any;
  @ViewChild('toastMessage') msgToast: any;
  @ViewChild('confirmationMessage', { static: true }) confirmationMessage: any;
  @Output() emitData = new EventEmitter();

  employees: any[];
  totalRecords: any;
  noOfRecords: any = 15;
  selectedArr: any = [];
  pageVal: any = 1;
  sortData: any;
  empIds: any[] = [];
  getSharedConstant = SharedConstant;
  public empAccntTblHeader: ManageEmpOrParticipantHeader = empOrParticipantTableHeader;
  currentParentNode: any;
  empAccTableCols: any[];
  subAccntNumbers: any[] = [];
  cancelButton = true;
  chkCompanyGrp: any;
  child = 0;
  parent = 0;
  moment = moment;
  bulkUploadClicked = false;
  sortField: any;
  pageNo: any = 1;
  param = {
    orgId: '',
    pageNumber: 1,
    pageSize: 1,
    sortField: ''
  };

  toggle = false;
  errMsg = [];
  filterClicked = false;
  filterBtnDisableForFN = false;
  filterBtnDisableForLN = false;
  filterBtnDisableForEmpId = false;
  filterBtnDisableForacctHolderFN = false;
  filterBtnDisableForacctHolderLN = false;
  invalidEmpId = false;
  invalidFN = false;
  invalidLN = false;
  invalidacctHolderFN = false;
  invalidacctHolderLN = false;
  manageEmpForm: UntypedFormGroup;
  isAccNumInvalid = false;
  schErrorMsg: string;
  showSchError = false;
  subAcctNum: any;
  empId: any;
  showActionMenu: boolean;
  actionMenu: any[];
  empHistoryData: any;
  deleteMsg: any;
  showToast = false;
  externalAccess = false;
  hasEMTRAccess = false;
  showActionItems = false;
  multiSortMeta: any = [];
  hasGrpOrPlanVal = '';
  hasShowRecordVal: any = '';
  ugGutTrackValue = 'adobe-dl_manageemployeesuserguide|fireonce';
  filterGutTrackValue = 'adobe-dl_manageemployeesuserguide|fireonce';
  isSortingChanged = false;
  defaultSortDataField = {field: 'updTs', order: -1};
  initialLoad = false;
  visibilityFlags = {
    bulkButtonHidden: false,
    acctNumFilterHidden: false,
    acctHolderFirstNameFilterHidden: false,
    acctHolderLastNameFilterHidden: false,
    actionMenuDisabled: false,
  };

  ngOnChanges(changes: SimpleChanges): void {
    this.selectedArr = [];
  }

  ngOnDestroy(): void {
    if (this.currentOrgSubscription) {
      this.currentOrgSubscription.unsubscribe();
    }
    /* Clear selectedGroupAndPlanNameInEmpGroup value when moving out of manage employees/participants page */
    this.sharedService.selectedGroupAndPlanNameInEmpGroup = '';
    this.sharedService.selectedGroupAndPlanIdInEmpGroup = '';
  }

  paramObj(pageNo, records, sortCol) {
    return this.param = {
      orgId: this.getOrgId,
      pageNumber: pageNo,
      pageSize: records,
      sortField: sortCol
    };
  }

  ngOnInit() {
    this.manageEmpForm = this.fb.group({
      empId: [''],
      lastName: [''],
      firstName: [''],
      acctHolderLn: [''],
      acctHolderFn: [''],
      subAcctNum: [''],
      status: [''],
      ruleIds: [''],
      updTs: ['']
    });
    this.empIds = [];
    this.subAccntNumbers = [];
    this.refreshVisibilityFlags();
    const pageNo = 1;
    const sortField = '';
    const noOfRecords = this.noOfRecords;
    this.multiSortMeta.push(this.defaultSortDataField);
    this.customSortService.sortArr = [];

    this.currentOrgSubscription = this.sharedService.clientInformation.subscribe(clientInfo => {
      if (clientInfo !== null) {
        this.showActionItems = this.sharedService.checkEntitlements(this.entitlementConst.navUUID.addLinkAppAccess.manageEmployee.uuid, '', '');
        this.hasEMTRAccess = this.sharedService.checkEntitlements(this.entitlementConst.navUUID.emtrAccess.ruleSummary.uuid, '', '');
        this.getOrgId = clientInfo.orgId;
        this.empAccTableCols = this.empAccntTblHeader[clientInfo.businessUnit];
        clientInfo.externalAccess && clientInfo.externalAccess === 'Y' ? this.externalAccess = true : this.externalAccess = false;
        this.toggle = false;
        this.multiSortMeta = [this.defaultSortDataField];
        this.messageService.clear();
        this.param.pageSize = this.noOfRecords = 15;
        this.sharedService.tableDropdownVal.next(15);
        this.resetForm();
        /* Clear selectedGroupAndPlanNameInEmpGroup value when ever the client is changed */
        if (this.sharedService.isClientChanged) {
          this.sharedService.selectedGroupAndPlanNameInEmpGroup = '';
          this.sharedService.selectedGroupAndPlanIdInEmpGroup = '';
        }
        this.sharedService.isClientChanged = false;
        if (this.sharedService.selectedGroupAndPlanNameInEmpGroup) {
          this.toggleFunction();
        }
        // if (this.sortField !== undefined) {
        //   console.log("In ngOnInit");
        //   this.getEmpAccntResponse(this.paramObj(pageNo, noOfRecords, this.sortField), true);
        // }
      }
    });
    this.onChange();
    this.sharedService.schErrorMsg.subscribe(value => {
      if (value.length > 0) {
        this.showSchError = true;
        this.schErrorMsg = value;
      } else {
        this.showSchError = false;
      }
    });
    this.getSuccessMessage();
  }

  getEmpAccntResponse(param, initialLoad) {
    const localUpdatedFormValues = this.manageEmpForm.getRawValue();
    const isAcctNumFilterHidden = this.visibilityFlags.acctNumFilterHidden;
    const isAcctHolderFirstNameFilterHidden = this.visibilityFlags.acctHolderFirstNameFilterHidden;
    const isAcctHolderLastNameFilterHidden = this.visibilityFlags.acctHolderLastNameFilterHidden;
    const filterObj: any = {
      active: this.hasShowRecordVal ? this.hasShowRecordVal.value : true,
      empId: localUpdatedFormValues.empId ? localUpdatedFormValues.empId.trim().toUpperCase() : null,
      accountNum: !isAcctNumFilterHidden && localUpdatedFormValues.subAcctNum ? this.sharedService.removeHypenAccountNum(localUpdatedFormValues.subAcctNum) : null,
      firstName: localUpdatedFormValues.firstName ? localUpdatedFormValues.firstName.trim().toUpperCase() : null,
      lastName: localUpdatedFormValues.lastName ? localUpdatedFormValues.lastName.trim().toUpperCase() : null,
      accountHolderFN: !isAcctHolderFirstNameFilterHidden && localUpdatedFormValues.acctHolderFn ? localUpdatedFormValues.acctHolderFn.trim().toUpperCase() : null,
      accountHolderLN: !isAcctHolderLastNameFilterHidden && localUpdatedFormValues.acctHolderLn ? localUpdatedFormValues.acctHolderLn.trim().toUpperCase() : null,
      groupId: this.hasGrpOrPlanVal ? this.hasGrpOrPlanVal : null
    };
    if (this.hasGrpOrPlanVal && this.sharedService.selectedGroupAndPlanIdType === 'ORG') {
      filterObj.groupId = null;
    }
    if (this.hasEMTRAccess && this.getOrgId !== undefined && this.getOrgId !== 0) {
      if (this.filterClicked) {
        this.sharedService.getEmployeeList(param, filterObj, null, null).subscribe((response) => {
          this.setEmployeeAccntListData(response);
        });
      } else {
        if (!this.sharedService.selectedGroupAndPlanNameInEmpGroup) {
          this.sharedService.getEmployeeList(param, '', null, null).subscribe((response) => {
            this.setEmployeeAccntListData(response);
          });
        }
      }
    }
  }

  setEmployeeAccntListData(response) {
    this.sharedService.clearErrorMessage();
    this.employees = response.data ? response.data.content : response.data;
    this.employees && this.employees.forEach(e => {
      e['ngomsStatus'] = false;
    });
    this.totalRecords = response.data ? response.data.totalElements : 0;
  }

  receiveDataFromChild(e) {
    this.pageNo = 1;
    this.sortField = this.param.sortField;
    this.noOfRecords = Number(e);
    this.paginator.changePage(0);
    this.messageService.clear();
    this.getEmpAccntResponse(this.paramObj(this.pageNo, this.noOfRecords, this.sortField), false);
  }

  customSort(event) {
    if (event.multiSortMeta) {
      this.paginator.changePage(0);
      if (this.sortField !== this.customSortService.customSort(event)) {
        this.sortField = this.customSortService.customSort(event);
        this.isSortingChanged = (JSON.stringify(event.multiSortMeta) === JSON.stringify([this.defaultSortDataField])) ? false : true;
        const noOfRecords = this.noOfRecords;
        if (this.sharedService.empListMultiSortMeta !== event.multiSortMeta && !this.initialLoad) {
          this.sharedService.empListMultiSortMeta = event.multiSortMeta;
          this.getEmpAccntResponse(this.paramObj(this.pageNo, noOfRecords, this.sortField), false);
          this.initialLoad = true;
        } else if (this.initialLoad && this.sharedService.empListMultiSortMeta !== event.multiSortMeta) {
          this.messageService.clear();
          this.sharedService.empListMultiSortMeta = event.multiSortMeta;
          this.getEmpAccntResponse(this.paramObj(this.pageNo, noOfRecords, this.sortField), false);
        }
      }
    }
  }

  paginate(e) {
    if (this.pageNo !== e.page + 1) {
      this.messageService.clear();
      this.pageNo = e.page + 1;
      this.sortField = this.param.sortField;
      const noOfRecords = this.noOfRecords;
      this.getEmpAccntResponse(this.paramObj(this.pageNo, noOfRecords, this.sortField), false);
    }
  }

  addOrEditEmp(empData: EmployeeDetails, empId: any, param) {
    /* created deep copy of rowdata for bug #15232*/
    const empDataClone = JSON.parse(JSON.stringify(empData));
    if (empId) {
      empDataClone.empId = empId;
    } else {
      empDataClone.empId = '';
    }
    this.sharedService.addOrEditEmployee = param;
    this.editEvent.emit(empDataClone);
  }

  updateEmployeeList(param) {
    param.sortField = this.param.sortField;
    this.paginator.changePage(0);
    this.getEmpAccntResponse(this.paramObj(param.pageNumber, param.pageSize, param.sortField), false);
  }

  uploadEmployeeList() {
    /* Set isDTBtnClicked value to true, generate the data track value with 'linkid-lc' . */
    this.sharedService.isDTBtnClicked =  true;
    this.sharedService.loadDataTrackValue('manageemployees_bulkupload');
    this.cancelButton = false;
    this.sharedService.parentPage = '/ems/emtr/manage-employees';
    this.bulkUploadClicked = true;
    this.router.navigate(['/ems/emtr/manage-employees/emp-bulk-upload']);
  }

  loadEmpHistory(ruleData) {
    this.empHistory.historyId = ruleData.subAcctNum;
    this.empHistory.employeeId = ruleData.empId;
    this.empHistory.empSubType = ruleData.type;
    this.empHistoryData = ruleData;
    this.empHistory.empName = this.getSharedConstant[this.businessUnit].employeeOrParticipantHistory + ' - ' + ruleData.acctHolderLN + ' ' + ruleData.acctHolderFN;
    this.sharedService.loadViewHistory(this.getOrgId, ruleData, 'empaccount', this.viewHistoryData);
  }

  getHistoryPagination(subAcctNum, data) {
    if (this.viewHistoryData.modalOpen) {
    this.sharedService.getHistoryPaginatedValues(this.empHistoryData, 'empaccount', data);
    }
  }

  onChange() {
    this.manageEmpForm.get('subAcctNum').valueChanges.subscribe(value => {
      /* check Account Number contains 8 digits */
      this.isAccNumInvalid = this.accountNumberValidationService.validateAccountNumber(value);
      this.sharedService.setErrorMessage(this.isAccNumInvalid, this.errMsg);
    });

    /* Validate the field and set the error message */
    this.manageEmpForm.get('empId').valueChanges.subscribe(value => {
      if (this.manageEmpForm.get('empId').errors?.emsStartSpacePattern !== false) {
      this.manageEmpForm.get('empId').setValue(value ? value.toUpperCase() : '', { emitEvent: false });
      this.filterBtnDisableForEmpId = this.sharedService.validationFields.filterBtnDisableForEmpId = this.sharedService.isValueLengthGreaterThan2(value);
      this.invalidEmpId = this.sharedService.validationFields.invalidEmpId = this.sharedService.isValidOrInvalid(value, 'empId', this.manageEmpForm);
      this.sharedService.setErrorMessage(this.isAccNumInvalid, this.errMsg); 
      }   
    });

    this.manageEmpForm.get('firstName').valueChanges.subscribe(value => {
       if ((this.manageEmpForm.get('firstName').errors?.emsStartSpacePattern !== false)) {
      this.manageEmpForm.get('firstName').setValue(value ? value.toUpperCase() : '', { emitEvent: false });
      this.filterBtnDisableForFN = this.sharedService.validationFields.filterBtnDisableForFN = this.sharedService.isValueLengthGreaterThan2(value);
      this.invalidFN = this.sharedService.validationFields.invalidFN = this.sharedService.isValidOrInvalid(value, 'firstName', this.manageEmpForm);
      this.sharedService.setErrorMessage(this.isAccNumInvalid, this.errMsg);
       }
    });

    this.manageEmpForm.get('lastName').valueChanges.subscribe(value => {
       if (this.manageEmpForm.get('lastName').errors?.emsStartSpacePattern !== false) {
      this.manageEmpForm.get('lastName').setValue(value ? value.toUpperCase() : '', { emitEvent: false });
      this.filterBtnDisableForLN = this.sharedService.validationFields.filterBtnDisableForLN = this.sharedService.isValueLengthGreaterThan2(value);
      this.invalidLN = this.sharedService.validationFields.invalidLN = this.sharedService.isValidOrInvalid(value, 'lastName', this.manageEmpForm);
      this.sharedService.setErrorMessage(this.isAccNumInvalid, this.errMsg);
       }
    });

    this.manageEmpForm.get('acctHolderFn').valueChanges.subscribe(value => {
       if (this.manageEmpForm.get('acctHolderFn').errors?.emsStartSpacePattern !== false) {
      this.manageEmpForm.get('acctHolderFn').setValue(value ? value.toUpperCase() : '', { emitEvent: false });
      this.filterBtnDisableForacctHolderFN = this.sharedService.validationFields.filterBtnDisableForacctHolderFN = this.sharedService.isValueLengthGreaterThan2(value);
      this.invalidacctHolderFN = this.sharedService.validationFields.invalidacctHolderFN = this.sharedService.isValidOrInvalid(value, 'acctHolderFn', this.manageEmpForm);
      this.sharedService.setErrorMessage(this.isAccNumInvalid, this.errMsg);
       }
    });

    this.manageEmpForm.get('acctHolderLn').valueChanges.subscribe(value => {
       if (this.manageEmpForm.get('acctHolderLn').errors?.emsStartSpacePattern !== false) {
      this.manageEmpForm.get('acctHolderLn').setValue(value ? value.toUpperCase() : '', { emitEvent: false });
      this.filterBtnDisableForacctHolderLN = this.sharedService.validationFields.filterBtnDisableForacctHolderLN = this.sharedService.isValueLengthGreaterThan2(value);
      this.invalidacctHolderLN = this.sharedService.validationFields.invalidacctHolderLN = this.sharedService.isValidOrInvalid(value, 'acctHolderLn', this.manageEmpForm);
      this.sharedService.setErrorMessage(this.isAccNumInvalid, this.errMsg);
       }
    });
  }

  toggleFunction() {
    this.toggle = !this.toggle;
    this.manageEmployeeDataService.filterToggleClicked = this.toggle;
  }

  clickedClearButton(resetSortFromUI?) {
    this.resetForm(resetSortFromUI);
    this.pageNo = 1;
    this.sortField = this.param.sortField;
    const noOfRecords = this.noOfRecords;
    this.getEmpAccntResponse(this.paramObj(this.pageNo, noOfRecords, this.sortField), false);
  }

  resetForm(resetSortFromUI?) {
    if (resetSortFromUI) {
      this.multiSortMeta = [this.defaultSortDataField];
    }
    this.manageEmployeeDataService.clearClicked.emit(true);
    this.manageEmpForm.reset();
    this.paginator.changePage(0);
    this.filterClicked = false;
    this.isAccNumInvalid = false;
    this.sharedService.schErrorMsg.emit('');
  }

  applyFilter() {
    this.paginator.changePage(0);
    this.filterClicked = true;
    this.pageNo = 1;
    this.sortField = this.param.sortField;
    const noOfRecords = this.noOfRecords;
    this.messageService.clear();
    this.getEmpAccntResponse(this.paramObj(this.pageNo, noOfRecords, this.sortField), false);
  }

  handleEnterKey(event: KeyboardEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.errMsg.length > 0 || this.manageEmpForm.invalid || this.isAccNumInvalid) {
      return;
    }
    this.applyFilter();
  }

  deleteEmployee(ruleData) {
    const accountNumber = this.accountNumbeFormatPipe.transform(ruleData.subAcctNum)
    const confirmObj = {
      header: `${this.getSharedConstant[this.businessUnit].removeEmployeeOrParticipant} - ${this.getSharedConstant[this.businessUnit].empOrParticipantsID}: ${ruleData.empId}`,
      /* eslint-disable-next-line max-len */
      message: `${this.getSharedConstant[this.businessUnit].removeEmployeeOrParticipantAlert}<br><strong>Account Number: </strong>${accountNumber}<br><strong>First Name: </strong>${ruleData.firstName}<br><strong>Last Name: </strong>${ruleData.lastName}<br>`,
      acceptBtn: this.getSharedConstant.deleteModal.yesTxt,
      rejectBtn: this.getSharedConstant.deleteModal.noTxt
    };
    const deleteFormData = {
      orgId: this.getOrgId,
      empId: ruleData.empId,
      subAccountNumber: ruleData.subAcctNum,
      forceDelete: true
    };
    new Observable<boolean>((observer) => {
      this.confirmationMessage.showConfirmMsg(confirmObj, observer);
    }).subscribe(accept => {
      if (accept) {
        this.showToast = false;
        this.sharedService.errorMessage.next(false);
        this.sharedService.deleteEmpAccount(deleteFormData).subscribe({
          next: (data) => {
            this.showToast = true;
            if (this.businessUnit !== 'RBS') {
              /* eslint-disable-next-line max-len */
              this.deleteMsg = '<strong>' + 'Employee ID: ' + ruleData.empId + '</strong> <strong>' + 'Account Number: ' + accountNumber + '</strong> - <strong>' + this.getSharedConstant.deleteModal.employeeTxt + '&nbsp;' + ruleData.lastName + ',' + ruleData.firstName + '</strong>&nbsp;' + this.getSharedConstant.deleteModal.deleteSuccessMsg;
            } else {
              /* eslint-disable-next-line max-len */
              this.deleteMsg = '<strong>' + 'Participant ID: ' + ruleData.empId + '</strong> <strong>' + 'Account Number: ' + accountNumber + '</strong> - <strong>' + this.getSharedConstant.deleteModal.participantTxt + '&nbsp;' + ruleData.lastName + ',' + ruleData.firstName + '</strong>&nbsp;' + this.getSharedConstant.deleteModal.deleteSuccessMsg;
            }
            this.msgToast.pushMessage('success', this.deleteMsg);
            this.emitData.emit();
          },
          error: (err) => {
            if (err.status === 400) {
              this.sharedService.clearErrorMessage();
              const failurMessage = err.error.message;
              this.msgToast.pushMessage('error', failurMessage);
            }
          }
        }
        );
      }
    });
  }

  formData(rowData) {
    this.actionMenu = ManageEmployeeOrParticpantListActionMenuItems[this.businessUnit].filter(item => item.label);
    if (this.sharedService.showHistoricalView.value) {
      this.actionMenu = this.actionMenu.filter(item => item.label === 'History');
    } else {
    if (!rowData.empId) {
      this.removeMenuItem([
        this.getSharedConstant[this.businessUnit].addEmployeeOrParticipant,
        this.getSharedConstant[this.businessUnit].removeEmployeeOrParticipant
      ]);
    }
    const ngoms = !this.activeEmployeeList() ? this.getSharedConstant[this.businessUnit].empNGOMSStatus : '';
    if (!this.showActionItems || this.hasShowRecordVal.value === false) {
      this.removeMenuItem([
        this.getSharedConstant[this.businessUnit].addEmployeeOrParticipant,
        'Edit',
        this.getSharedConstant[this.businessUnit].removeEmployeeOrParticipant,
        ngoms
      ]);
    }
    if (!this.sharedService.checkEntitlements(this.entitlementConst.navUUID.ngOMS.employeeSyncSummary.uuid, '', '')) {
      this.removeMenuItem([
        this.getSharedConstant[this.businessUnit].empNGOMSStatus,
      ]);
      }
    }
    const sharedConstant = this.getSharedConstant[this.businessUnit];
    [
      ['ellipsisEditButton', 'Edit'],
      ['ellipsisAddEmployeeButton', sharedConstant.addEmployeeOrParticipant],
      ['ellipsisRemoveEmployeeButton', sharedConstant.removeEmployeeOrParticipant]
    ].forEach(([componentName, menuLabel]) => {
      if (this.visibilityCheckForUIComponent(componentName)) {
        this.removeMenuItem([menuLabel as string]);
      }
    });
    this.actionMenu = this.actionMenu.map(item => ({...item, command: (event) => this.onActionMenuClick(event, rowData)}));
    return this.actionMenu;
  }

  removeMenuItem(removeItem) {
    this.actionMenu = this.actionMenu.filter(actionMenu => {
      return !removeItem.some(removeActionMenu => actionMenu['label'] === removeActionMenu);
    });
  }

  @HostListener('document:click', [])
  onClick() { /* Capture the Click Event outside the function */
    if (!this.showActionMenu) {
      this.empId = '';
      this.subAcctNum = '';
    }
    this.showActionMenu = false;
  }

  onActionButtonKeydown(event: KeyboardEvent, rowData: any): void {
    this.sharedService.openActionMenuOnKeydown(event, () => {
      this.showActionMenu = true;
      this.empId = rowData['empId'];
      this.subAcctNum = rowData['subAcctNum'];
      this.formData(rowData);
    });
  }

  onActionMenuClick(event: any, ruleData: any) {
    const actionItem = event.item?.label;
    this.messageService.clear();
    this.sharedService.clearErrorMessage();
    if (actionItem === 'Edit') {
      this.addOrEditEmp(ruleData, ruleData.empId, 'editEmployee');
    } else if (actionItem === 'History') {
      this.loadEmpHistory(ruleData);
    } else if (actionItem === this.getSharedConstant[this.businessUnit].addEmployeeOrParticipant) {
      this.addOrEditEmp(ruleData, ruleData.empId, 'addEployee');
    } else if (actionItem === this.getSharedConstant[this.businessUnit].removeEmployeeOrParticipant) {
      this.deleteEmployee(ruleData);
    } else if (actionItem === this.getSharedConstant[this.businessUnit].empNGOMSStatus) {
      this.ngOMSStatusCheck(ruleData);
    }
  }

  getSuccessMessage() {
    this.manageEmployeeDataService.getMessage().subscribe((data) => {
      this.landingPageMsg = data.text ? data.text : '';
      if (this.landingPageMsg.indexOf(':') > -1) {
        const accountNumberFormat = this.landingPageMsg.split(':');
        accountNumberFormat[1] = this.accountNumbeFormatPipe.transform(accountNumberFormat[1].replace(/\s/g, ''));
        this.landingPageMsg = `${accountNumberFormat[0]} : ${accountNumberFormat[1]}`;
      }
      if (this.landingPageMsg && this.landingPageMsg !== null && this.landingPageMsg !== '') {
        setTimeout(() => {
          if (this.landingPageMsg && this.landingPageMsg !== undefined) {
            this.msgToast.pushMessage('success', this.landingPageMsg);
          }
        }, 1);
      }
    });
  }

  activeEmployeeList() {
    return this.hasShowRecordVal?.value ?? true;
  }

  // ngOMS Prod Support Engineer role to verify status check
  ngOMSStatusCheck(ruleData) {
    const formData = {
      orgId: this.getOrgId,
      subAccountNumber: ruleData.subAcctNum,
    };
    this.sharedService.ngOMSStatusCheck(formData).subscribe({
      next: () => {
        this.employeeListUpdate(ruleData, true);
      },
      error: () => {
        this.employeeListUpdate(ruleData, false);
        this.sharedService.clearErrorMessage();
      },
      complete: () => {
        this.sharedService.clearErrorMessage();
      }
    });
  }

  employeeListUpdate(ruleData, flag) {
    this.employees.forEach(e => {
      if (e.empId === ruleData.empId && e.subAcctNum === ruleData.subAcctNum) {
        e.ngomsStatusCheck = flag;
        e.ngomsStatus = true;
      }
    });
  }
  // id sanitizer for headers with <br> tag
  sanitizeHeaderId(col: any) {
    return col.replace(/<br\s*\/?>/gi, '').replace(/\s+/g, '');
  }

  refreshVisibilityFlags(): void {
    this.visibilityFlags.bulkButtonHidden = this.visibilityCheckForUIComponent('bulkButton');
    this.visibilityFlags.acctNumFilterHidden = this.visibilityCheckForUIComponent('acctNumFilter');
    this.visibilityFlags.acctHolderFirstNameFilterHidden = this.visibilityCheckForUIComponent('acctHolderFirstNameFilter');
    this.visibilityFlags.acctHolderLastNameFilterHidden = this.visibilityCheckForUIComponent('acctHolderLastNameFilter');
    this.visibilityFlags.actionMenuDisabled = this.visibilityCheckForUIComponent('actionMenuDisabled', 'DISABLE');
  }

  visibilityCheckForUIComponent(componentName: string, action: 'HIDE' | 'DISABLE' = 'HIDE') {
    const ui = this.getSharedConstant.visibilityUIComponents;
    const visibilityMap: { [key: string]: any } = {
      actionMenuDisabled: ui.manageEmployeeActionMenu,
      bulkButton: ui.manageEmployeesBulkUploadButton,
      ellipsisEditButton: ui.manageEmployeesEllipsisEditButton,
      ellipsisAddEmployeeButton: ui.manageEmployeesEllipsisAddEmployeeButton,
      ellipsisRemoveEmployeeButton: ui.manageEmployeesEllipsisRemoveEmployeeButton,
      acctNumFilter: ui.employeesListAcctNbrFilterRulesSteps3,
      acctHolderFirstNameFilter: ui.employeesListAcctholderFirstNameFilterRulesSteps3,
      acctHolderLastNameFilter: ui.employeesListAcctholderLastNameFilterRulesSteps3
    };
    const visibilityKey = visibilityMap[componentName];
    if (!visibilityKey) {
      // Fail-safe: unknown keys should not accidentally expose controls.
      return action === 'HIDE';
    }
    return this.sharedService.hasUIVisibilityExclusionAction(visibilityKey, action, 'employee');
  }
}
